<template>
  <section 
    class="c-shoppable-ugc"
  >
    <header>
      <h3 class="t-heading-3 u-text-align-center u-margin-bottom-small">
        {{ title }}
      </h3>
      <p class="t-paragraph-large u-text-align-center u-margin-bottom-medium">
        {{ cta }}
      </p>
    </header>
    <div :class="ugcLayout">
      <nuxt-link
        v-for="item in mappedLinks"
        :key="item.id"
        class="c-shoppable-ugc__link"
        :to="item.url"
      >
        <nuxt-img
          class="c-shoppable-ugc__image"
          v-bind="$getImgOptions(item.backgroundImage, {
            title: item.title,
            height: 227.6
          })"
        />
        <template v-if="item.attribution && item.attributionType">
          <component
            :is="item.attributionType"
            class="c-shoppable-ugc__link__source"
            :href="item.attribution"
          />
        </template>
      </nuxt-link>
    </div>
  </section>
</template>

<script>
//import get from 'lodash/get'
import { UrlFilters } from '@mixins/cdnMixins'
import InstagramIconLink from '../socialMedia/InstagramIconLink'
import PinterestIconLink from '../socialMedia/PinterestIconLink'
import TwitterIconLink from '../socialMedia/TwitterIconLink'
import FacebookIconLink from '../socialMedia/FacebookIconLink'
export default {
  filters: {
    productLink(handle) {
      return `/products/${handle}`
    }
  },
  components: {
    InstagramIconLink,
    PinterestIconLink,
    TwitterIconLink,
    FacebookIconLink,
  },
  mixins: [
    UrlFilters
  ],
  props: {
    tiles: {
      type: [Number, String],
      default: 10,
    },
    title: {
      type: String,
      default: "#EnsoGoes",
    },
    cta: {
      type: String,
      default: "Shop Our Instagram",
    },
    openLinksInNewTab: {
      type: Boolean,
      default: true,
    },
    links: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ugcLayout() {
      let result = []
      result.push(
        'c-shoppable-ugc__grid',
        'l-grid',
      )
      return result
    },
    mappedLinks() {
      const links = this.links
      let result = []
      for (let link of links) {
        let item = { id: link.id, ...link.data }
        if (item.attribution) {
          if (item.attribution.includes('instagram.com')) {
            item.attributionType = 'instagram-icon-link'
          } else if (item.attribution.includes('pinterest.com')) {
            item.attributionType = 'pinterest-icon-link'
          } else if (item.attribution.includes('facebook.com')) {
            item.attributionType = 'facebook-icon-link'
          } else if (
            item.attribution.includes('twitter.com') ||
            item.attribution.includes('x.com')
          ) {
            item.attributionType = 'twitter-icon-link'
          }
        }
        result.push(item)
      }
      return result
    },
  },
};
</script>

<style lang="scss" scoped>
.c-shoppable-ugc {
  padding: rem(20px) 0;
  &__grid {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-gap: rem(20px);
    max-width: rem(1400px);
    margin-left: auto;
    margin-right: auto;
    @include respond(tab-land) {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }
    @include respond(tab-port) {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
    @include respond(phone) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
  &__link {
    width: 227.6px;
    height: 227.6px;
    cursor: pointer;
    overflow: hidden;
    position: relative;
    &__source {
      position: absolute;
      bottom: 1rem;
      right: 1rem;
      &::v-deep g {
        @include themify($themes) {
          fill: themed("accent");
        }
      }
    }
  }
  &__image {
    height: 227.6px;
  }
}
</style>
